import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails, PlaceListResponseDTO } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetFequentDestinationCommand extends IRequestCommand<
  IGetFequentDestinationResponse,
  ErrorDetails,
  IGetFequentDestinationCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'passengers/{passengerUserId}/frequentDestinations?destinationType={destinationType}';
  override _needAuthenticate = true;

  public override setParameters(parameters: IGetFequentDestinationCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{passengerUserId}',
      parameters.id.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{destinationType}',
      parameters.destinationType.toString()
    );
  }
}

export interface IGetFequentDestinationCommandParameters
  extends ICommandParameters {
  id: string;
  destinationType: string;
}

export interface IGetFequentDestinationResponse
  extends ICommandResponse,
    PlaceListResponseDTO {
  forEach(arg0: (element: any) => void): any;
}
